import { TextField, Typography, Grid2 as Grid, Divider } from "@mui/material";

interface TemplateBasicInfoProps {
  templateId: number;
  description: string;
}

const TemplateBasicInfo = ({
  templateId,
  description,
}: TemplateBasicInfoProps) => {
  return (
    <>
      <Grid size={12}>
        <Typography variant="body2" fontWeight={600} sx={{ mb: 0.5 }}>
          Basic Information
        </Typography>
        <Divider sx={{ mb: 1 }} />
      </Grid>

      <Grid size={{ xs: 12, md: 6 }}>
        <TextField
          label="Template ID"
          value={templateId}
          disabled
          size="small"
          fullWidth
        />
      </Grid>

      <Grid size={{ xs: 12, md: 6 }}>
        <TextField
          label="Description"
          value={description}
          disabled
          size="small"
          fullWidth
        />
      </Grid>
    </>
  );
};

export default TemplateBasicInfo;
